import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FBF3EA]/90 backdrop-blur-md border-b border-[#15193D]/5" data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-95">
        <div className="flex items-center justify-between" data-id="element-96">
          {/* Logo */}
          <a href="#" className="flex items-center" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/4Prt8voGX9NE1GpiEStH1D/Frame_16865625112.png" alt="Famday" className="h-20 w-20 rounded-2xl object-cover" data-id="element-98" />
          </a>

          {/* Nav links */}
          <div className="hidden md:flex items-center gap-8" data-id="element-99">
            <a href="#features" className="text-[#15193D]/70 hover:text-[#15193D] font-medium transition-colors" data-id="element-100">
              Features
            </a>
            <a href="#download" className="text-[#15193D]/70 hover:text-[#15193D] font-medium transition-colors" data-id="element-101">
              Download
            </a>
          </div>

          {/* CTA Button */}
          <button className="bg-[#15193D] text-[#FBF3EA] px-8 py-3.5 rounded-full font-semibold hover:bg-[#15193D]/90 hover:scale-105 transition-all shadow-md" data-id="element-102">
            Download App
          </button>
        </div>
      </div>
    </nav>;
}